angular.module('qiehaoServiceModule', []).factory('qiehaoService', [
    '$q',
    '$window',
    'editIsLock',
    'ueditorService',
    'trsHttpService',
    'trsspliceString',
    'editingCenterService',
    'storageListenerService',
    'editcenterRightsService',
    function($q, $window, editIsLock, ueditorService, trsHttpService, trsspliceString, editingCenterService, storageListenerService, editcenterRightsService) {
        return {

            /**
             * [addFuture 为控制器作用域增加通用功能]
             *
             * @param   {[type]}  vm              [vm description]
             * @param   {[type]}  methodNameList  [methodNameList description]
             *
             * @return  {[type]}                  [return description]
             */
            addFuture: function (vm, methodNameList) {
                for (var i = 0; i < methodNameList.length; i++) {
                    let methodName = methodNameList[i];
                    vm[methodName] = this[methodName];
                }
                return vm;
            },

            /**
             * [sendmessage 发送消息到IM]
             *
             * @return  {[type]}  [return description]
             */
            sendmessage: function () {
                let that = this;
                this.save(true).then((data) => {
                    const outerSourceId = that.list.METADATAID;
                    const title = that.list.TITLE;
                    let articleDocType = editingCenterService.getDocTypeId();
                    let articleMediaType = editingCenterService.getEditPageMediaType();
                    let url = getDetailUrl(articleMediaType);
                    const extraInfo = {
                        'articleDocType': articleDocType,
                        'articleMediaType': articleMediaType,
                        'articleUrl': url,
                        'mediatype': articleMediaType,
                        'account': $state.params.qiehaoaccount,
                        'metadataid': outerSourceId,
                        'chnldocid': that.list.CHNLDOCID,
                        'channelid': that.list.CHANNELID
                    };
                    const info = {
                        messageBody: {
                            content: '',
                            extraInfo: JSON.stringify(extraInfo),
                            messageType: 'ARTICLE_DOC', 
                            outerSourceId: outerSourceId,
                            platform: '',
                            title: title
                        },
                        outerSourceId: '',
                        oprType: getOprType(),
                        objId: $state.params.qiehaoaccount
                    };
                    editingCenterService.sendToStudio(info).then(function(result){
                        if (result.ISSUCCESS === 'true') {
                            setTimeout(() => {
                                window.close();
                            }, 2000);
                        }
                    });
                });
            },

            /**
             * [initSelect description]稿件类型下拉过滤
             * @return  {[type]}  [return description]
             */
            initSelect: function() {
                return [
                    {
                        name: '全部稿件',
                        value: '',
                    },
                    {
                        name: '新闻',
                        value: '1',
                    },
                    {
                        name: '图集',
                        value: '2',
                    },
                    {
                        name: '视频',
                        value: '7',
                    },
                ];
            },

            /**
             * [initEditPath:function description]初始化编辑页路径
             * @return  {[type]}  [return description]
             */
            initEditPath: function() {
                var editPath = {
                    1: 'qiehaonews',
                    2: 'qiehaoatlas',
                    7: 'qiehaovideo',
                };
                return editPath;
            },

            /**
             * [initEditerBtn description] 编辑页权限按钮
             * @return  {[type]}  [return description]
             */
            initEditerBtn: function(platform, account) {
                var defer = $q.defer();
                var compaildbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '送审',
                        OPERFUN: 'qiehaoTrial',
                        rightKey: 'kuaibao.daibian.songshen'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'qiehaoSign',
                        rightKey: 'kuaibao.daibian.qianfa'
                        
                    },
                ];
                let pendingbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '撤稿',
                        OPERFUN: 'qiehaoKill',
                        rightKey: 'kuaibao.daishen.chegao'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'qiehaoSign',
                        rightKey: 'kuaibao.daishen.qianfa'
                    },
                ];
                var arrayBtns = [compaildbtn, pendingbtn];
                editcenterRightsService.initQieHaoListBtn(['kuaibao.daibian', 'kuaibao.daishen'][platform], account).then(function(rights) {
                    var btns = arrayBtns[platform];
                    defer.resolve(btns.filter(function(btn) {
                        return !btn.rightKey || rights[btn.rightKey];
                    }));
                });
                return defer.promise;
            },

            /**
             * [initEditPath:function description]获取文章分类
             * @param   {[type]}  docType    [docType description] 稿件类型
             * @return  {[type]}  [return description]
             */
            getArticleClass: function(docType) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_kuaibaoarticleclass',
                    methodname: 'query',
                    docType: docType,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },

            /**
             * [requestListImg description:查询列表图示]
             * @param   {[type]}  items    [docType description] 选中的稿件对象数组
             * @return  {[type]}             [return description]
             */
            requestListImg: function(items) {
                var defer = $q.defer();
                if (!items || items.length < 1) {
                    defer.resolve([]);
                } else {
                    var params = {
                        serviceid: 'mlf_kuaibaoarticle',
                        methodname: 'queryAllImgLogo',
                        ArticleIds: trsspliceString.spliceString(items, 'KUAIBAOARTICLEID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        angular.forEach(items, function(value, key) {
                            value.ALLIMG = data[value.KUAIBAOARTICLEID];
                        });
                        defer.resolve(items);
                    });
                }
                return defer.promise;
            },

            /**
             * [qiehaoEditor description] 企鹅号编辑页面跳转
             * @param   {[type]}  docType    [docType description] 稿件类型
             * @param   {[type]}  account    [account description] 企鹅号账号id
             * @param   {[type]}  articleid  [articleid description] 稿件id
             * @param   {[type]}  platform   [platform description] 待编、待审权限控制
             * @return  {[type]}             [return description]
             */
            qiehaoEditor: function(docType, account, articleid, platform) {
                var routerName = `#/${this.initEditPath()[docType]}?qiehaoaccount=${account}&qiehaoarticleid=${articleid}&qiehaoplatform=${platform}`;
                editIsLock.isLock({METADATAID: articleid}, 19).then(function (data) {
                    if (data.ISLOCK === 'false') {
                        window.open(routerName);
                    } else {
                        editIsLock.checkUnlockPermissions({METADATAID: articleid}, data).then(function () {
                            window.open(routerName);
                        });
                    }
                });
            },

            /**
             * [qiehaoUnlock description] 企鹅号解锁方法
             *
             * @param   {[type]}  form       [form description] form表单名称
             * @param   {[type]}  articleid  [articleid description] 稿件id
             * @param   {[type]}  save       [save description] 保存方法
             * @param   {[type]}  list       [list description] 稿件数据
             *
             * @return  {function}           [return description]
             */
            qiehaoUnlock: function(form, articleid, save, list) {
                var flag = window.UE ? ueditorService.contentTranscoding(list) !== ueditorService.bindContent() : false;
                editingCenterService
                    .closeWinow(form.$dirty, flag)
                    .then(
                        function() {
                            save().then(function() {
                                storageListenerService.addListenerToQiehao('save');
                                editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                });
                            });
                        },
                        function() {
                            angular.isDefined(articleid)
                                ? editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                })
                                : $window.close();
                        }
                    );
            }
        };
    },
]);
